module.exports = __webpack_public_path__ + "img/sqlserver-client.23057124.svg";